var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11.275 3c-1.46 0-2.702 1.172-2.702 2.552 0 .207 0 .414.073.551C6.382 5.966 4.41 5 3.096 3.413c-.22.346-.366.828-.366 1.311 0 .897.439 1.655 1.169 2.138a2.57 2.57 0 01-1.242-.345c0 1.242.95 2.276 2.118 2.483-.219.069-.438.069-.73.069-.146 0-.365 0-.511-.069.365 1.034 1.314 1.724 2.483 1.793-.95.69-2.045 1.104-3.36 1.104-.219 0-.438 0-.657-.07C3.169 12.588 4.63 13 6.09 13c4.966 0 7.595-3.931 7.595-7.31v-.345c.512-.345.95-.828 1.315-1.31a6.34 6.34 0 01-1.534.413c.585-.345.95-.827 1.169-1.448a6.939 6.939 0 01-1.68.62c-.219-.344-.876-.62-1.68-.62"}));
}

Twitter.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Twitter;

Twitter.default = Twitter;
